import { ViewRouteConfig } from '@scoring-web/configs/route/route.type';
import { lazyWithPreload } from '@ui/utils/lazy.util';

const LazyLoginView = lazyWithPreload(() => import('./login.view'));

const loginRoute: ViewRouteConfig = {
  lazy: { Component: async () => LazyLoginView },
  path: '/login',
};

export default loginRoute;
